module.exports = __webpack_public_path__ + "img/07.795c951e.jpg";